import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

// HeyCatch analytics — must be at module scope in the client entry so
// autocapture (pageviews, clicks, SPA route changes) starts before the
// router mounts. Idempotent + no-op during SSR; the key is publishable.
analytics.init({
    projectKey: "hck_pk_cBX5kWYDtzW9DWLzEildFkDxzWNQNZWV",
    install: {
        framework: "react",
        frameworkVersion: "19",
        agent: "other",
    },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
